import MainLayout from "../components/Layouts/MainLayout";
import MemPool from "../components/mempool";

export default function MempoolPage() {
  return (
    <MainLayout activeId="mempool" isRoomView={true}>
      <MemPool />
    </MainLayout>
  );
}
